var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "407984A9-B147-429B-B8DD-1AE425CB3115") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HomepageOK-1080px",
    transform: "translate(-905.000000, -5748.000000)",
    fill: "#FDC609",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bandeau-boost",
    transform: "translate(0.000000, 5602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(854.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gratuit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "002-correct",
    transform: "translate(51.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0096483,23.8305845 C14.3217287,23.140582 13.2038593,23.140582 12.5159397,23.8305845 C11.8280201,24.520587 11.8280201,25.641841 12.5159397,26.3318435 L20.6419902,34.4824981 C20.98595,34.8274994 21.4158997,35 21.8888445,35 C21.9318394,35 21.9318394,35 21.9748344,35 C22.4477792,34.9568748 22.9207239,34.7412491 23.2646837,34.3531227 L43.6013073,9.90115892 C44.203237,9.16803125 44.117247,8.04677719 43.3863324,7.39989984 C42.6554179,6.79614765 41.5375485,6.88239796 40.8926238,7.61552562 L21.7598595,30.601234 L15.0096483,23.8305845 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1998806,3.81933881 C28.2890261,-2.37825226 15.5772779,-0.914932146 7.30386888,7.34852261 C-2.43462296,17.0752975 -2.43462296,32.9566246 7.30386888,42.6833994 C12.1731148,47.5467869 18.5936249,50 24.9710443,50 C31.3484638,50 37.7689739,47.5467869 42.6382198,42.6833994 C50.9547195,34.3769059 52.3767116,21.6374131 46.1285642,11.7384829 C45.6114762,10.9207452 44.5342094,10.6625123 43.7154866,11.1789782 C42.8967638,11.6954441 42.6382198,12.7714148 43.1553079,13.5891525 C48.5416418,22.1108402 47.2920124,33.0427022 40.1389608,40.1871475 C31.7793705,48.5366799 18.1196275,48.5366799 9.76003718,40.1871475 C1.40044684,31.8376151 1.40044684,18.194307 9.76003718,9.84477456 C16.9130887,2.74336813 27.8150287,1.49524216 36.3469817,6.78901786 C37.1657045,7.30548378 38.2429713,7.04725082 38.7600593,6.22951311 C39.2771474,5.4117754 39.0186034,4.33580473 38.1998806,3.81933881 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.05429bfd7458749397be5ad0e62f085d.svg";
export { ForwardRef as ReactComponent };